import { add } from 'date-fns';

export function getMinimumEntryDate(minimumOffsetInSeconds: number) {
	return add(new Date(), { seconds: minimumOffsetInSeconds });
}
